import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BRAND_LOGO_SRC } from '@/lib/brandAssets';

export { BRAND_LOGO_SRC };

export function BrandMark({ size = 24, className = '' }) {
  const { t } = useTranslation();
  return (
    <span className={`inline-flex items-center justify-center ${className}`} style={{ width: size, height: size }}>
      <img src={BRAND_LOGO_SRC} alt={t('common.app_name')} style={{ width: size, height: size, objectFit: 'contain' }} />
    </span>
  );
}

export function BrandLogo({ size = 28, showText = true, to = '/', className = '' }) {
  const { t } = useTranslation();
  const content = (
    <span className={`flex items-center gap-2 ${className}`}>
      <BrandMark size={size} />
      {showText && (
        <span className="font-display font-bold tracking-tight" style={{ fontSize: size * 0.78, color: '#FF6B35' }}>
          {t('common.app_name')}
        </span>
      )}
    </span>
  );
  if (to) return <Link to={to} data-testid="brand-logo-link">{content}</Link>;
  return content;
}
